
import {zip as observableZip,  Observable, Subscription } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { PaymentMethod } from '../../models/subscriptions/subscription.enums';
import { BookingDto, TrainingPaymentDto } from '../../models/training/training.models';
import { PaymentService } from '../../services/payment.service';
import { RouterService } from '../../services/routerService';
import { TrainingService } from '../../services/training.service';

@Component({
    selector: 'training/payment',
    template: require('./training.payment.component.html'),
    styles: [require('./training.shared.css')]
})
export class TrainingPaymentComponent implements OnInit {

    booking: BookingDto;
    trainingService: TrainingService;
    routeParamsSub: Subscription;

    paymentMethods;
    paymentMethod: PaymentMethod;
    errors: string;
    selectedAccountId: number;
    hideCardPayment: boolean;
    agreedToTandCs: boolean;
    poNumber: string;
    existingId: number;
    @ViewChild('cardPayment', { static: false }) private cardPayment: any;
    @BlockUI() blockUi: NgBlockUI;
    showAgreeToTandCsText = false;
    isLive: boolean;
    digicertScript: string;
    private readonly selectedAccount = 'selectedAccount';
    

    constructor(trainingService: TrainingService,
        configuration: Configuration,
        helpers: Helpers,
        private router: Router,
        private route: ActivatedRoute,
        private readonly routerService: RouterService,
        private loggedInUserService: LoggedInUserService,
        private paymentService: PaymentService,
        config: Configuration) {

        this.trainingService = trainingService;
        this.booking = new BookingDto();

        var user = loggedInUserService.getCurrentUser();

        this.paymentMethods = PaymentMethod;
        this.paymentMethod = PaymentMethod.Card;
        
        this.errors = '';
        this.isLive = config.environmentInfo.environmentName === 'Live';
        this.digicertScript = '<!-- Begin DigiCert site seal HTML --><div id = "DigiCertClickID_0pV4B5mp" data-language="en" class="left' + `${this.isLive ? '' : ' allow-test-seal'}` + '"></div><!--End DigiCert site seal HTML--><!--Begin DigiCert site seal JavaScript code--><script type = "text/javascript">var __dcid = __dcid || []; __dcid.push(["DigiCertClickID_0pV4B5mp", "10", "l", "black", "0pV4B5mp"]); (function () { var cid = document.createElement("script"); cid.async = true; cid.src = "//seal.digicert.com/seals/cascade/seal.min.js"; var s = document.getElementsByTagName("script"); var ls = s[(s.length - 1)]; ls.parentNode.insertBefore(cid, ls.nextSibling); }());</script><!--End DigiCert site seal JavaScript code-->';
    }

    ngOnInit(): void {

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            const id = +params['id'];

            var eventObservable = this.trainingService.getBooking(id);

            observableZip(
                eventObservable,
                (booking: BookingDto) => ({ booking }))
                .subscribe(results => {
                    this.booking = results.booking;                
                });
        });

        const fragment = document.createRange().createContextualFragment(this.digicertScript);
        document.getElementById('ssl-img-container').appendChild(fragment);
        $('#t-and-c-modal').modal();
        $('#t-and-c-modal').modal('hide');
    }

    ngAfterViewInit() {
        this.cardPayment.show();
    }

    paymentMethodChanged(paymentMethod: PaymentMethod) {
        if (paymentMethod === PaymentMethod.Card) {
            this.cardPayment.show();
        }
    }

    submit() {
        this.errors = '';

        if (this.paymentMethod === undefined || this.paymentMethod === null) {
            this.errors = 'You must select a payment method.';
            return;
        } else if (this.paymentMethod === PaymentMethod.Card) {
            this.errors = 'You must complete the card submission form.';
            return;
        } else if ((this.paymentMethod === PaymentMethod.BACS) &&
            !this.poNumber) {
            this.errors = 'You must enter a PO number or email address for BACS.';
            return;
        }

        if (!this.agreedToTandCs) {
            this.errors = 'You must agree to the terms and conditions.';
            return;
        }

        this.blockUi.start();

        const dto = new TrainingPaymentDto();

        dto.bookingId = this.booking.id;
        dto.paymentMethod = this.paymentMethod;
        dto.customerId = this.loggedInUserService.getCurrentUser().userId;
        dto.additionalInformation = this.poNumber;

        this.trainingService.pay(dto).subscribe((response: any) => {
            this.routerService.router.navigateByUrl(`/training/confirm/${response.value}`);
            this.blockUi.stop();
        },
            () => { this.blockUi.stop(); });
    }

    cardSubscription(tokenResult) {
        this.errors = '';

        this.trainingService.cardPay({
            paymentMethod: PaymentMethod.Card,
            customerId: this.loggedInUserService.getCurrentUser().userId,
            stripeToken: tokenResult.source,
            is3DSecure: tokenResult.threeDSecure,
            clientSecret: tokenResult.clientSecret,
            bookingId: this.booking.id
        }).subscribe(
            (response: any) => {
                var subscriptionResult = response.value;
                var paymentId = subscriptionResult.paymentId;
                this.paymentService.sendSubscriptionReceipt(paymentId);
                window.location.href = subscriptionResult.redirectUrl;
                this.blockUi.stop();
            },
            () => {
                this.blockUi.stop();
                this.hideCardPayment = false;
            });
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.payment.component.ts